import React from 'react';
import SwipeableViews from 'react-swipeable-views-react-18-fix';

const TabsContentListSwipeableLayout = ({
  children,
  index,
  onChangeIndex,
  isSwipePrevented = false,
}) => {
  const swipeableContainerStyle = {
    height: '100%',
    boxSizing: 'border-box',
  };

  return (
    <SwipeableViews
      axis="x"
      animateTransitions
      enableMouseEvents
      index={index}
      // SwipeableViews['onChangeIndex'] type is wrong, our type is correct
      onChangeIndex={onChangeIndex}
      containerStyle={swipeableContainerStyle}
      className="ws-ui-tabs__content-list-layout"
      disabled={isSwipePrevented}
    >
      {children}
    </SwipeableViews>
  );
};

export default TabsContentListSwipeableLayout;
